<template>
  <el-card class="box-card" ref="card" shadow="never">
    <!--    <h3> 品牌Top10</h3>-->
    <div class="d-flex-row justify-content-between">
      <span style="font-size: 18px;font-weight: bold;">品牌Top10</span>
      <el-link type="primary" icon="el-icon-refresh" @click="getData">刷新</el-link>
    </div>
    <el-table class="dashboard-table"
              :data="data"
              :row-class-name="rowClassName"
              :row-style="{ border: 'none',padding:'15px 0'}"
              :cell-style="{ border: 'none'}"
              style="width: 100%">
      <el-table-column prop="index" label="排名"/>
      <el-table-column prop="brand_name" label="品牌"/>
      <el-table-column prop="order_money" :label="`订单金额\u2002(元)\u2002\u2002\u2002`">
        <template slot-scope="scope">
          <span class="money">{{ gFunc.numberFormat(scope.row.order_money) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="order_count" label="订单量" align="right" sortable="custom"/>
    </el-table>
  </el-card>
</template>

<script>
import {detailBrandV2} from "@/api/dashboard";

export default {
  name: "detailBrandV2",
  props: {
    year: [Number, String],
    artistId: {
      type: [Number, String],
      default: 0
    },
    saleId: {
      type: [Number, String],
      default: 0
    },
    uidKeyId: {
      type: [Number, String],
      default: 0
    },
    organizationId: {
      type: [Number, String],
      default: 'ALL'
    },
  },
  data() {
    return {
      data: [],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.data = [];
      detailBrandV2({
        year: this.year,
        artist_id: this.artistId,
        organization_id: this.organizationId,
        sale_id: this.saleId,
        uid_key_id: this.uidKeyId
      }).then(res => {
        this.data = res.model.data;
      })
    },
    rowClassName({row, rowIndex}) {
      row.index = rowIndex + 1
    },
  }
}
</script>

<style scoped>

</style>
